import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
      }}
    >
      <CircularProgress
        size={60}
        sx={{
          color: '#13287e', 
        }}
      />
      <Typography
        sx={{
          marginTop: 2,
          fontSize: '18px',
          color: '#13287e',
          fontWeight:'bold'
        }}
      >
        Loading...
      </Typography>
    </Box>
  );
};

export default Loading;
